import { FC } from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';
import colors from 'constants/colors';
import Icon, { IconNames } from 'components/Icon';

interface Props {
  isOpen: boolean;
  closeModal?: () => void;
  children: React.ReactNode;
  contentClassName?: string;
  contentLabel?: string;
}

export const ModalComponent: FC<Props> = ({
  isOpen,
  closeModal,
  children,
  contentClassName,
  contentLabel,
}) => {
  return (
    <Modal
      appElement={document.getElementById('root') as HTMLElement}
      isOpen={isOpen}
      onRequestClose={closeModal}
      className={classNames('modal-component-content', contentClassName)}
      overlayClassName="modal-component-overlay"
      contentLabel={contentLabel}
    >
      {children}
      {closeModal && (
        <Icon
          onClick={closeModal}
          name={IconNames.XClose}
          size={16}
          color={colors.inkBlue}
          className="close-button"
        />
      )}
    </Modal>
  );
};
